
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesQuotationGrid extends Serenity.EntityGrid<SalesQuotationRow, any> {
        protected getColumnsKey() { return 'Sales.Quotation'; }
        protected getDialogType() { return SalesQuotationDialog; }
        protected getIdProperty() { return SalesQuotationRow.idProperty; }
        protected getInsertPermission() { return SalesQuotationRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesQuotationRow.localTextPrefix; }
        protected getService() { return SalesQuotationService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        } 
        protected addButtonClick() {

            let now = new Date(); 
            var voucherNo = FormatHelper.GetVoucherNo(55);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<SalesQuotationRow>{
                VoucherNo: voucherNo, 
                VoucherTypeId: 55,
                CompanyId:userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString()
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}